import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocIconComponent } from '@ng-doc/ui-kit/components/icon';
const _c0 = ["ng-doc-blockquote", ""];
const _c1 = ["*"];
function NgDocBlockquoteComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r0.icon);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 3);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 4);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 5);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 6);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_0_Template, 1, 0, "ng-doc-icon", 3)(1, NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_1_Template, 1, 0, "ng-doc-icon", 4)(2, NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_2_Template, 1, 0, "ng-doc-icon", 5)(3, NgDocBlockquoteComponent_Conditional_0_Conditional_2_Case_3_Template, 1, 0, "ng-doc-icon", 6);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_2_0 = ctx_r0.type) === "note" ? 0 : tmp_2_0 === "warning" ? 1 : tmp_2_0 === "success" ? 2 : tmp_2_0 === "alert" ? 3 : -1);
  }
}
function NgDocBlockquoteComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, NgDocBlockquoteComponent_Conditional_0_Conditional_1_Template, 1, 1, "ng-doc-icon", 2)(2, NgDocBlockquoteComponent_Conditional_0_Conditional_2_Template, 4, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.icon ? 1 : 2);
  }
}
let NgDocBlockquoteComponent = /*#__PURE__*/(() => {
  class NgDocBlockquoteComponent {
    constructor() {
      this.type = 'default';
    }
    static {
      this.ɵfac = function NgDocBlockquoteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocBlockquoteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocBlockquoteComponent,
        selectors: [["blockquote", "ng-doc-blockquote", ""]],
        hostVars: 1,
        hostBindings: function NgDocBlockquoteComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-ng-doc-type", ctx.type);
          }
        },
        inputs: {
          type: "type",
          icon: "icon"
        },
        attrs: _c0,
        ngContentSelectors: _c1,
        decls: 3,
        vars: 1,
        consts: [[1, "ng-doc-blockquote-icon"], [1, "ng-doc-blockquote"], ["size", "24", 3, "icon"], ["icon", "info", "size", "24"], ["icon", "alert-triangle", "size", "24"], ["icon", "check", "size", "24"], ["icon", "alert-circle", "size", "24"]],
        template: function NgDocBlockquoteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocBlockquoteComponent_Conditional_0_Template, 3, 1, "div", 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.type !== "default" ? 0 : -1);
          }
        },
        dependencies: [NgDocIconComponent],
        styles: ["[_nghost-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);position:relative;display:flex;padding:calc(var(--ng-doc-base-gutter) * 2);border-radius:var(--ng-doc-base-gutter);margin:var(--ng-doc-blockquote-margin);background:color-mix(in srgb,var(--ng-doc-blockquote-background, var(--ng-doc-base-9)),transparent 90%);border:1px solid color-mix(in srgb,var(--ng-doc-blockquote-border-color, var(--ng-doc-base-9)),transparent 80%);overflow:hidden;--ng-doc-code-margin: var(--ng-doc-base-gutter) 0}[data-ng-doc-type=note][_nghost-%COMP%]{--ng-doc-blockquote-background: var(--ng-doc-info);--ng-doc-blockquote-border-color: var(--ng-doc-info);--ng-doc-icon-color: var(--ng-doc-info)}[data-ng-doc-type=warning][_nghost-%COMP%]{--ng-doc-blockquote-background: var(--ng-doc-warning);--ng-doc-blockquote-border-color: var(--ng-doc-warning);--ng-doc-icon-color: var(--ng-doc-warning)}[data-ng-doc-type=alert][_nghost-%COMP%]{--ng-doc-blockquote-background: var(--ng-doc-alert);--ng-doc-blockquote-border-color: var(--ng-doc-alert);--ng-doc-icon-color: var(--ng-doc-alert)}[data-ng-doc-type=success][_nghost-%COMP%]{--ng-doc-blockquote-background: var(--ng-doc-success);--ng-doc-blockquote-border-color: var(--ng-doc-success);--ng-doc-icon-color: var(--ng-doc-success)}[_nghost-%COMP%]   .ng-doc-blockquote-icon[_ngcontent-%COMP%]{display:flex;margin-right:calc(var(--ng-doc-base-gutter) * 2)}[_nghost-%COMP%]   .ng-doc-blockquote[_ngcontent-%COMP%]{text-decoration:none}[_nghost-%COMP%]     p{margin:0}"],
        changeDetection: 0
      });
    }
  }
  return NgDocBlockquoteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocBlockquoteComponent };
